import React, { useMemo } from 'react';
import { SearchFilterContainer } from './search-filter-container';
import { BED_OPTIONS } from '../../util/listing-search.constants';
import { iconBed } from '../../util/icons';

export interface BedroomsProps {
  isOpen: boolean;
  bedrooms: string[];
  isFloating?: boolean;
  setSearchOption(key: string, value: string | number | object): void;
  open(): void;
  close(): void;
}

export const Bedrooms: React.FC<BedroomsProps> = props => {
  const enableBedrooms = (value: string) =>
    !props.bedrooms.includes(value) && props.setSearchOption('bedrooms', [...props.bedrooms, value]);

  const disableBedrooms = (value: string) =>
    props.bedrooms.includes(value) && props.setSearchOption('bedrooms', props.bedrooms.slice(0, props.bedrooms.indexOf(value)).concat(props.bedrooms.slice(props.bedrooms.indexOf(value) + 1)));

  const title = <div className="form-field-label"><span><span className="icon">{iconBed}</span> Bedrooms</span></div>

  const f = (
    <div className="form-field">
      <div className="filter-options">
        {BED_OPTIONS.map((option, i) => <button key={i} className={props.bedrooms.includes(option.value) ? 'filter-option-button selected' : 'filter-option-button'} onClick={() => props.bedrooms.includes(option.value) ? disableBedrooms(option.value) : enableBedrooms(option.value)}>{option.label}</button>)}
      </div>
    </div>
  );

  const label = useMemo(() => {
    if (props.bedrooms.length === 1) {
      for (let option of BED_OPTIONS) {
        for (let selectedOption of props.bedrooms) {
          if (option.value === selectedOption) {
            return option.label + ' Bed';
          }
        }
      }
    } else if (props.bedrooms.length > 1) {
      return 'Bedrooms (' + props.bedrooms.length + ')';
    }
    return 'Bedrooms';
  }, [props.bedrooms]);

  const cssClass = useMemo(() => {
    return props.isOpen ? 'filter-button filter-button-selected' : props.bedrooms.length !== 0 ? 'filter-button filter-button-enabled' : 'filter-button'
  }, [props.isOpen, props.bedrooms]);

  if (!props.isFloating) {
    return (
      <div>
        {title}
        {f}
      </div>
    );
  }

  return (
    <div>
      <button className={cssClass} onClick={props.open}>{label}</button>
      {props.isOpen &&
        <SearchFilterContainer title={title} close={props.close} alignRight>
          {f}
        </SearchFilterContainer>
      }
    </div>
  );
}
